exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sns-panel{position:fixed;right:20px;bottom:228px;z-index:2;display:flex;flex-direction:column;gap:16px;transition:opacity .2s ease-out;opacity:1}@media (max-width:576px){.sns-panel{right:16px;bottom:50%;transform:translateY(50%)}}.sns-panel a,.sns-panel button{margin:0;padding:0;height:48px;width:48px}.sns-panel.is--hidden{opacity:0;pointer-events:none}@media (max-width:576px){.sns-panel.is--hidden{opacity:1;pointer-events:auto}}", ""]);

// exports
